export default __webpack_public_path__ + "static/media/main-app-banner.f8eb98a715dea46ad8aac3e30b867fb9.jpg";